import { atomWithStorage } from 'jotai/utils';

export interface Country {
  id?: string;
}

export const userPrefsAtom = atomWithStorage('app.user.prefs', {
  country: {} as Country,
  language: '',
});
